import type { ReactNode } from 'react';

interface Props {
  /** A way back, where there is one — "← Results". Left out on a top-level page. */
  eyebrow?: ReactNode;
  title: string;
  /** Short lines of context under the title — counts, status, last import. */
  meta?: ReactNode;
  actions?: ReactNode;
}

/**
 * The top of a page: where you are, what it is called, and the one or two
 * things you came to do.
 *
 * The actions stand beside the title rather than under a rule below it, which
 * is where the eye goes looking for "add" or "import" — the title says what
 * the page holds and the button beside it says what can be done to it.
 */
export function PageHeader({ eyebrow, title, meta, actions }: Props) {
  return (
    <header className="pagehead rise">
      <div className="pagehead__text">
        {eyebrow && <p className="eyebrow pagehead__eyebrow">{eyebrow}</p>}
        <h1 className="pagehead__title">{title}</h1>
        {meta && <div className="pagehead__meta">{meta}</div>}
      </div>
      {actions && <div className="pagehead__actions">{actions}</div>}
    </header>
  );
}
